import React from "react";
import { UseFormReturn } from "react-hook-form";
import CustomInput from "src/components/CustomInput";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";

import { Button } from "src/components/ui/button";
import { Form } from "src/components/ui/form";
import { PackageSubCategoryFormType } from "./api/interfaces";

interface PackageSubCategoryFormModalProps {
  isShow: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: UseFormReturn<PackageSubCategoryFormType, any, any>;
  type: "CREATE" | "EDIT";
}

const PackageSubCategoryFormModal: React.FC<
  PackageSubCategoryFormModalProps
> = ({ isShow, onClose, onSubmit, form, type }) => {
  return (
    <Dialog open={isShow} onOpenChange={onClose}>
      <DialogContent className="max-w-fit">
        <DialogHeader>
          <DialogTitle className="text-md font-semibold text-darkBrown-default">
            {`${type === "CREATE" ? "Create" : "Edit"} Package Sub Category`}
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 pt-2 w-[860px]">
          <Form {...form}>
            <div className="w-full grid gap-4 mb-12">
              <CustomInput
                form={form}
                name="name"
                labelText="Package Sub-Category Name"
                placeholder="Input Name"
              />

              <CustomInput
                form={form}
                name="color"
                labelText="Label / Tag Color"
                variant="color-picker"
              />
            </div>
          </Form>
        </div>

        <DialogFooter>
          <Button onClick={onSubmit} isLoading={form.formState.isSubmitting}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PackageSubCategoryFormModal;
